import i18n from '@/utils/i18n';

const filters =
  [
    {
      name: "users.global",
      id: "global",
      placeholder: i18n.t('users.global_placeholder'),
      value: "",
      type: "text",
      label: i18n.t('users.global'),
      main: true,
      columns: 3,
      icon: 'search'
    },
    {
      name: "users.company",
      id: "company",
      placeholder: i18n.t('users.company_placeholder'),
      value: "",
      type: "text",
      label: i18n.t('users.company'),
      main: true,
      columns: 3
    },
    {
      name: "paid_subscriptions",
      type: "select",
      multiple: false,
      searchable: false,
      label: i18n.t('users.paid_status'),
      placeholder: i18n.t('form.any'),
      options: [
        {
          value: "",
          label: i18n.t('form.any'),
        },
        {
          value: true,
          label: i18n.t('paid_status.paid'),
        },
        {
          value: false,
          label: i18n.t('paid_status.free'),
        }
      ],
      main: true,
      columns: 2
    },
    {
      name: "users.job",
      id: "job",
      placeholder: i18n.t('users.job_placeholder'),
      value: "",
      type: "text",
      label: i18n.t('users.job'),
      main: false
    },
    {
      name: "userresourcerelationships.suspended",
      type: "select",
      main: false,
      multiple: false,
      searchable: false,
      label: i18n.t('users.user_status'),
      placeholder: i18n.t('form.any'),
      preselectFirst: true,
      options: [
        {
          value: "",
          label: i18n.t('form.any'),
        },
        {
          value: false,
          label: i18n.t('user_status.true'),
        },
        {
          value: true,
          label: i18n.t('user_status.false'),
        }
      ]
    },
    {
      name: "userplanrelationships.is_trial",
      type: "select",
      main: false,
      multiple: false,
      searchable: false,
      label: i18n.t('users.user_trial'),
      placeholder: i18n.t('form.any'),
      preselectFirst: true,
      options: [
        {
          value: "",
          label: i18n.t('form.any'),
        },
        {
          value: true,
          label: i18n.t('user_trial.true'),
        },
        {
          value: false,
          label: i18n.t('user_trial.false'),
        }
      ]
    },
    {
      name: "userplanhistory.is_trial",
      type: "select",
      main: false,
      multiple: false,
      searchable: false,
      label: i18n.t('users.user_trial_history'),
      placeholder: i18n.t('form.any'),
      preselectFirst: true,
      options: [
        {
          value: "",
          label: i18n.t('form.any'),
        },
        {
          value: true,
          label: i18n.t('user_trial.true'),
        },
        {
          value: false,
          label: i18n.t('user_trial.false'),
        }
      ]
    },
    {
      name: "teams.count",
      type: "select",
      main: false,
      multiple: false,
      searchable: false,
      label: i18n.t('users.group_subscription_attachment'),
      placeholder: i18n.t('form.any'),
      options: [
        {
          value: "",
          label: i18n.t('form.any')
        },
        {
          value: 0,
          label: i18n.t('form.without_group')
        },
        {
          value: -1,
          label: i18n.t('form.any_group')
        }
      ]
    },
    {
      name: "userplanrelationships.autorenew",
      type: "select",
      main: false,
      multiple: false,
      searchable: false,
      label: i18n.t('form.auto_renew_status'),
      placeholder: i18n.t('form.any'),
      options: [
        {
          value: "",
          label: i18n.t('form.any')
        },
        {
          value: true,
          label: i18n.t('global.true')
        },
        {
          value: false,
          label: i18n.t('global.false')
        }
      ]
    },
    {
      name: "teams.id",
      placeholder: i18n.t('form.type_to_search'),
      type: "select",
      label: i18n.t('form.group'),
      multiple: true,
      searchable: true,
      options_url: "teams?limit=100",
      filter_field: 'name',
      main: false
    },
    {
      name: "country",
      placeholder: i18n.t('form.type_to_search'),
      type: "select",
      label: i18n.t('form.country'),
      multiple: false,
      options_url: "countries",
      main: false
    },
    {
      name: "tags.slug",
      placeholder: i18n.t('form.type_to_search'),
      type: "select",
      label: i18n.t('form.tags'),
      multiple: true,
      options_url: "tags",
      filter_field: 'slug',
      main: false
    },
    {
      name: "user_subscriptions",
      placeholder: i18n.t('form.any'),
      value: "user_subscriptions",
      type: "select",
      group: false,
      searchable: false,
      label: i18n.t('form.attached_plan_and_subscription'),
      multiple: false,
      main: false,
      options: [
            {
              value: 'any',
              label: i18n.t('form.any_plan_attached')
            },
            {
              value: 'without_any',
              label: i18n.t('form.no_plan_attached')
            },
            {
              value: 'free',
              label: i18n.t('paid_status.free')
            },
            {
              value: 'paid',
              label: i18n.t('paid_status.paid')
            }

      ]
    },
    {
      name: "subscriptions.id",
      id: "",
      placeholder: i18n.t('form.type_to_search'),
      type: "select",
      label: i18n.t('form.subscriptions_id'),
      filter_field: 'title',
      searchable: true,
      multiple: true,
      group: true,
      groupSelect: true,
      options_url: "plans?limit=100",
      main: true
    },
    {
      name: "userplanrelationships.created_at",
      type: "date",
      label: i18n.t('form.subscription_start_date'),
      main: false,
      mode: 'date',
      isRange: true
    },
    {
      name: "userplanrelationships.subscription_end_date",
      label: i18n.t('form.subscription_end_date'),
      type: "date",
      main: false,
      mode: 'date',
      isRange: true
    },
    {
      name: "userplanhistory.subscription_id",
      label: i18n.t('form.subscription_plan_history'),
      type: "select",
      filter_field: 'title',
      searchable: true,
      multiple: true,
      group: true,
      options_url: "plans?limit=100",
      main: false
    },
    {
      name: "invites.code",
      type: "text",
      label: i18n.t('form.invitation_code_used'),
      placeholder: i18n.t('form.invitation_code_placeholder'),
      main: false,
    },
    {
      name: "ti_event_tickets.id",
      id: "ti_event_tickets_ids",
      placeholder: i18n.t('form.type_to_search'),
      type: "select",
      label: i18n.t('form.events_and_tickets'),
      filter_field: 'title',
      searchable: true,
      multiple: true,
      group: true,
      options_url: "ti-events?limit=100",
      items_key: "tickets",
      main: false
    },
    {
      name: "ti_event_tickets_owner.id",
      id: "ti_event_tickets_owner_ids",
      placeholder: i18n.t('form.type_to_search'),
      type: "select",
      label: i18n.t('form.owner_events_of_tickets'),
      filter_field: 'title',
      searchable: true,
      multiple: true,
      group: true,
      options_url: "ti-events?limit=100",
      items_key: "tickets",
      main: false
    },
    {
      name: "has_user_activity",
      type: "select",
      main: false,
      multiple: false,
      searchable: false,
      label: i18n.t('form.has_user_activity'),
      placeholder: i18n.t('form.any'),
      options: [
        {
          value: "",
          label: i18n.t('form.any')
        },
        {
          value: true,
          label: i18n.t('global.true')
        },
        {
          value: false,
          label: i18n.t('global.false')
        }
      ]
    },
    {
      name: "not_active_period",
      type: "select",
      main: false,
      multiple: false,
      searchable: false,
      label: i18n.t('form.not_active_period'),
      placeholder: i18n.t('form.any'),
      options: [
        {
          value: "",
          label: i18n.t('form.any')
        },
        {
          value: "1 day",
          label: i18n.t('global.day', {number: 1})
        },
        {
          value: "2 days",
          label: i18n.t('global.days', {number: 2})
        },
        {
          value: "3 days",
          label: i18n.t('global.days', {number: 3})
        },
        {
          value: "4 days",
          label: i18n.t('global.days', {number: 4})
        },
        {
          value: "5 days",
          label: i18n.t('global.days', {number: 5})
        },
        {
          value: "6 days",
          label: i18n.t('global.days', {number: 6})
        },
        {
          value: "7 days",
          label: i18n.t('global.days', {number: 7})
        },
        {
          value: "8 days",
          label: i18n.t('global.days', {number: 8})
        },
        {
          value: "9 days",
          label: i18n.t('global.days', {number: 9})
        },
        {
          value: "10 days",
          label: i18n.t('global.days', {number: 10})
        },
        {
          value: "30 days",
          label: i18n.t('global.days', {number: 30})
        },
        {
          value: "2 month",
          label: i18n.t('global.months', {number: 2})
        },
        {
          value: "6 month",
          label: i18n.t('global.months', {number: 6})
        }
      ]
    },
  ];

export default filters
